// extracted by mini-css-extract-plugin
export default {"headBox":"HeadersJsonUI_headBox__VWJ3n","headEntity":"HeadersJsonUI_headEntity__HQiQ-","headerKey":"HeadersJsonUI_headerKey__PcD2m","table":"HeadersJsonUI_table__F+hHO"};